/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import ReduxUtils from '../../utils/ReduxUtils';
import { LIBRARY_ROOT } from '../../utils/Constants';
import RESOURCE_NAMES from '../../api/resources';
/**
 * SSO Verifier action types.
 */

var SSO_VERIFIER = ReduxUtils.generateActionType(LIBRARY_ROOT, RESOURCE_NAMES.ssoVerifier, 'SSO_VERIFIER');
/* eslint-disable import/prefer-default-export */

export { SSO_VERIFIER };